<ng-container [ngSwitch]="bookingStore.bookingPlansLoadedState$ | async">
  <div
    class="flex flex-col gap-[24px] lt-md:gap-[16px]"
    *ngSwitchCase="BookingPlansLoadingState.Loaded"
  >
    <ng-container
      *ngIf="
        (bookingStore.error$ | async) === noInstallationsError;
        then bookingPlansError;
        else bookingPlans
      "
    ></ng-container>
    <ng-template #bookingPlans>
      <ng-container *ngIf="bookingStore.subscriptionsPlans$ | async as bookingPlans">
        <div class="plans-wrapper">
          <div class="headers-row flex flex-row">
            <div class="flex-[100%] max-w-[60%]">
              {{ '+BOOKING.PLAN.FEATURE.PACKAGE_CONTENT' | translate }}
            </div>
            <div
              data-at-basic-content
              class="flex flex-col justify-start items-center flex-[100%] max-w-[20%]"
            >
              {{ '+BOOKING.PLAN.BASIC_PACKAGE' | translate }}
              <p class="header-description">
                {{ '+BOOKING.PLAN.BASIC_PACKAGE_DESCRIPTION' | translate }}
              </p>
            </div>
            <div
              data-at-pro-content
              class="flex flex-col justify-start items-center flex-[100%] max-w-[20%]"
            >
              {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
              <p class="header-description">
                {{ '+BOOKING.PLAN.PRO_PACKAGE_DESCRIPTION' | translate }}
              </p>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.QUICK_CHECK_DASHBOARD' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.GUIDED_COMMISSIONING' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.ERROR_LIST' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.BASIC_PARAMETERS' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              <span>
                {{ '+BOOKING.PLAN.FEATURE.EXTENDED_PARAMETERS' | translate }}
              </span>

              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.EXTENDED_PARAMETERS' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              <span>
                {{ '+BOOKING.PLAN.FEATURE.PARAMETER_COMPARISION' | translate }}
              </span>

              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PARAMETER_COMPARISION' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.SYSTEM_OVERVIEW' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.TRENDING' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.TRENDING' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.GUIDED_TROUBLESHOOTING' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.GUIDED_TROUBLESHOOTING' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.PERMANENT_INSPECTION' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PERMANENT_INSPECTION' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PREDICTIVE_MAINTANANCE' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature" data-at-package-content-row>
            <div data-at-package-content-title class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate }}
              <mat-icon
                data-at-package-content-tooltip-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.AUTOMATED_RECOMMENDATIONS' | translate"
                >info_outline</mat-icon
              >
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div data-at-package-content-icon class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>

          <div class="prices-row gt-md:!flex flex-row !hidden">
            <div class="flex-[100%] max-w-[60%]"></div>
            <div
              class="price-details flex flex-col justify-start items-center flex-[100%] max-w-[20%]"
            >
              <p class="price-info">{{ '+BOOKING.PLAN.BASIC_PACKAGE_DESCRIPTION' | translate }}</p>
            </div>
            <div class="pro-package-price flex-[100%] max-w-[20%]">
              <ng-container *ngTemplateOutlet="proPackagePrice"></ng-container>
            </div>
          </div>

          <div class="pro-package-frame">
            <div class="pro-frame-subtitle !hidden gt-md:!block">
              {{ '+BOOKING.PLAN.BEST_SELLING_PACKAGE' | translate }}
            </div>
          </div>
        </div>

        <div class="pro-package-panel !hidden lt-lg:!block">
          <div class="pro-frame-subtitle">
            {{ '+BOOKING.PLAN.BEST_SELLING_PACKAGE' | translate }}
          </div>
          <ng-container *ngTemplateOutlet="proPackagePrice"></ng-container>
        </div>

        <ng-template #proPackagePrice>
          <div class="price-details flex flex-col justify-start items-center">
            <div class="price-details-section flex flex-col justify-start items-center">
              <ng-container *ngIf="(bookingStore.subscriptionsDetails$ | async)?.price as price">
                <span
                  >{{ price.net.toFixed(2) | number: '1.2-2':'de-DE' }}
                  {{ price.currency }}
                  <mat-icon inline="true" [matTooltip]="'+BOOKING.PRICE.PRICE_TOOLTIP' | translate"
                    >info_outline</mat-icon
                  >
                </span>
                <p class="price-info price-info-bold">
                  {{ '+BOOKING.PRICE.YEARLY_PLUS_VAT' | translate }}
                </p>
              </ng-container>
            </div>
            <div class="price-details-section flex flex-col md:flex-row sm:flex-row">
              <div
                [matTooltip]="
                  (bookingStore.getActiveProSubscriptionForFlatRate$ | async)
                    ? ('+BOOKING.OVERVIEW.BUTTON.FLAT_RATE.PRO_DISABLED' | translate)
                    : null
                "
              >
                <button
                  data-at-buy-Pro-button
                  mat-raised-button
                  color="primary"
                  (click)="selectPlan(BookingPlans.Pro)"
                  gtm="onSelect"
                  gtmAction="Pro package"
                  gtmCategory="booking"
                  [disabled]="
                    (bookingStore.getActiveProSubscriptionForFlatRate$ | async) ||
                    !(remoteConfigStore.isBookingProButtonEnabled$ | async)
                  "
                >
                  {{ '+BOOKING.OVERVIEW.BUTTON.BUY_PRO' | translate }}
                </button>
              </div>
              <!-- temporarily commented out booking trials for flatrate -->
              <!-- https://app.asana.com/0/1208110730359700/1206589954694954 -->
              <!-- <div
                [matTooltip]="
                  (bookingStore.getActiveProSubscriptionForFlatRate$ | async)
                    ? ('+BOOKING.OVERVIEW.BUTTON.FLAT_RATE.PRO_DISABLED' | translate)
                    : (bookingStore.getActiveTrialSubscriptionForFlatRate$ | async)
                    ? ('+BOOKING.OVERVIEW.BUTTON.FLAT_RATE.TRIAL_DISABLED' | translate)
                    : null
                "
              >
                <button
                  data-at-buy-Trial-button
                  mat-stroked-button
                  (click)="selectPlan(BookingPlans.Trial)"
                  gtm="onSelect"
                  gtmAction="Test for free Pro package"
                  gtmCategory="booking"
                  [disabled]="bookingStore.activeOrCanceledFlatRateSubscription$ | async"
                >
                  {{ '+BOOKING.OVERVIEW.BUTTON.TEST_FOR_FREE' | translate }}
                </button>
              </div> -->
            </div>
            <!-- <p
              class="price-info"
              *ngIf="(bookingStore.trialSubscriptions$ | async)?.period?.months as months"
            >
              {{ '+FLAT_BOOKING.PRICE.TEST_FOR_FREE' | translate: { monthsNumber: months } }}
              <mat-icon
                inline="true"
                [matTooltip]="
                  '+FLAT_BOOKING.PRICE.TEST_FOR_FREE_TOOLTIP' | translate: { monthsNumber: months }
                "
                >info_outline</mat-icon
              >
            </p> -->
          </div>
        </ng-template>

        <app-flat-booking-plans-spec></app-flat-booking-plans-spec>

        <div class="references flex flex-col gap-[16px]">
          <p>{{ '+FLAT_BOOKING.OVERVIEW.PAYMENT.PAYMENT_REFERENCE' | translate }}</p>
          <p>{{ '+FLAT_BOOKING.OVERVIEW.PAYMENT.PAYMENT_REFERENCE_SECOND' | translate }}</p>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #bookingPlansError>
      <div
        class="error-container flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
      >
        <img src="assets/img/installer-error.svg" />
        <h1>{{ '+BOOKING.PLANS.ERROR.TITLE' | translate }}</h1>
        <button
          class="back-button"
          gtm="onGoToPage"
          gtmAction="Home Page"
          gtmCategory="booking"
          mat-raised-button
          color="primary"
          [routerLink]="['/installations']"
        >
          <mat-icon>arrow_back</mat-icon>
          <span>{{ '+BOOKING.PLANS.ERROR.BTN' | translate }}</span>
        </button>
      </div>
    </ng-template>
  </div>

  <ng-container *ngSwitchCase="BookingPlansLoadingState.Loading">
    <vi-loader data-at-loader [isLoading]="true"></vi-loader>
  </ng-container>

  <ng-container *ngSwitchCase="BookingPlansLoadingState.Error">
    <div class="flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center">
      <img class="error-img" src="assets/img/installer-error.svg" />
      <h1>{{ '+BOOKING.PLANS.ERROR_TIMEOUT_TITLE' | translate }}</h1>
    </div>
  </ng-container>
</ng-container>
